import { render } from "./ContinueRegister.vue?vue&type=template&id=bb856036&scoped=true"
import script from "./ContinueRegister.vue?vue&type=script&lang=js"
export * from "./ContinueRegister.vue?vue&type=script&lang=js"

import "./ContinueRegister.vue?vue&type=style&index=0&id=bb856036&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-bb856036"

export default script